import { Pipe, PipeTransform } from '@angular/core';
import { PRINT_ORDER_STATUSES } from '../constants';

@Pipe({
  name: 'thesisOrderStatus'
})
export class ThesisOrderStatusPipe implements PipeTransform {

  printorderstatuses = PRINT_ORDER_STATUSES;

  transform(value: number): any {
    return this.printorderstatuses.filter(status => status.id === value)[0];
  }

}
